import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { useAppContext } from "../../../_context";
import Image from "next/image";
import Button from "../../Misc/Button";

const ExclusiveAccess = () => {
  const [{ tx }] = useAppContext();

  return (
    <section className="exclusive-access-section position-relative mw-1920 mx-auto section-padding-top">
      <Container>
        <Row>
          <Col md={6}>
            <div className="exclusive-access-image-container">
              <Image
                src="/img/clubs/exclusive-access.png"
                width={466}
                height={828}
                unoptimized={true}
              />
            </div>
          </Col>
          <Col md={6} className="d-flex align-items-center position-relative">
            <div className="w-100 mb-4 mb-md-0">
              <h2>{tx["Get exclusive access to club features"]}</h2>
              <p>
                {
                  tx[
                    "We strongly believe that local clubs like yours are a vital part of the sports community. That's why we're constantly working on adding new features to increase court bookings and membership take up, and help clubs thrive in the modern, digital world. Take advantage of our free trial for early adopters, and get ahead of the competition."
                  ]
                }
              </p>
              <Button href="/clubs/signup">{tx["Sign up today"]}</Button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ExclusiveAccess;
